import { render, staticRenderFns } from "./ChooseFilterDialog.vue?vue&type=template&id=bc56e004&scoped=true"
import script from "./ChooseFilterDialog.vue?vue&type=script&lang=js"
export * from "./ChooseFilterDialog.vue?vue&type=script&lang=js"
import style0 from "./ChooseFilterDialog.vue?vue&type=style&index=0&id=bc56e004&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc56e004",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc56e004')) {
      api.createRecord('bc56e004', component.options)
    } else {
      api.reload('bc56e004', component.options)
    }
    module.hot.accept("./ChooseFilterDialog.vue?vue&type=template&id=bc56e004&scoped=true", function () {
      api.rerender('bc56e004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/ChooseFilterDialog.vue"
export default component.exports